import React, { useEffect, useState } from "react";
import { Link as DomLink } from "react-router-dom";
import { Mobile, Default } from "../../../utils/deviceHelpers";
import api from "../../../utils/api";
import qs from "qs";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import LandingFooter from "./LandingFooter";
import Button from "@mui/material/Button";
import Container from "@mui/material/Container";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Divider from "@mui/material/Divider";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { constants } from "../../../utils";

export default function StaticSubLanding(props) {
  const [isLoaded, setIsLoaded] = useState(false);
  const [banner, setBanner] = useState();
  const [twocolumns, setTwoColumns] = useState();
  const [threecards, setThreeCards] = useState();
  const [bottomgreen, setBottomGreen] = useState();
  const [icons, setIcons] = useState();

  const frontImageUrl = constants.CMS_FRONT_IMAGE_URL;

  const page =
    props.match.params.PageType === "Harmony-Recycled-Precious-Metals"
      ? constants.HARMONY_RECYCLED_PRECIOUS_METALS_ID
      : props.match.params.PageType === "Lab-Grown-Diamonds"
      ? constants.LAB_GROWN_DIAMONDS_ID
      : props.match.params.PageType === "Harmony-Recycled-Diamonds"
      ? constants.HARMONY_RECYCLED_DIAMONDS_ID
      : props.match.params.PageType === "Artisanal-Metals"
      ? constants.ARTISANAL_METALS
      : props.match.params.PageType === "Our-Green-Refinery"
      ? constants.OUR_GREEN_REFINERY_ID
      : props.match.params.PageType === "Harmony-Diamond-Auctions"
      ? constants.HARMONY_DIAMOND_AUCTIONS
      : props.match.params.PageType === "The-Hoover-And-Strong-Experts"
      ? constants.THE_HOOVER_AND_STRONG_EXPERTS
      : props.match.params.PageType === "Responsibility-Statements-And-Policies"
      ? constants.RESPONSIBILITY_STATEMENTS_AND_POLICIES
      : props.match.params.PageType === "Our-History"
      ? constants.OUR_HISTORY
      : props.match.params.PageType === "Volume-Discount-Programs"
      ? constants.VOLUME_DISCOUNT_PROGRAMS
      : props.match.params.PageType === "Shipping-Options"
      ? constants.SHIPPING_OPTIONS
      : props.match.params.PageType === "Payment-Information"
      ? constants.PAYMENT_INFORMATION
      : props.match.params.PageType === "Diamond-Services"
      ? constants.DIAMOND_SERVICES
      : props.match.params.PageType === "Diamond-Sources"
      ? constants.DIAMOND_SOURCES
      : props.match.params.PageType === "Finishing-And-Milgrain-Options"
      ? constants.FINISHING_AND_MILGRAIN_OPTIONS
      : props.match.params.PageType === "Customer-Service-Team"
      ? constants.CUSTOMER_SERVICE_TEAM
      : props.match.params.PageType === "What-We-Refine"
      ? constants.WHAT_WE_REFINE
      : props.match.params.PageType === "Stone-Removal"
      ? constants.STONE_REMOVAL
      : props.match.params.PageType === "Finding-Your-Metal-Scrap"
      ? constants.FINDING_YOUR_METAL_SCRAP
      : props.match.params.PageType === "Maximize-Your-Return"
      ? constants.MAXIMIZE_YOUR_RETURN
      : props.match.params.PageType === "Buying-Jewelry-Scrap"
      ? constants.BUYING_JEWELRY_SCRAP
      : props.match.params.PageType === "Free-Sweeps-Box"
      ? constants.FREE_SWEEPS_BOX
      : props.match.params.PageType === "Preparing-Your-Shipment"
      ? constants.PREPARING_YOUR_SHIPMENT
      : props.match.params.PageType === "Analytical-Services"
      ? constants.ANALYTICAL_SERVICES
      : props.match.params.PageType === "What-You-Need-To-Know"
      ? constants.WHAT_YOU_NEED_TO_KNOW
      : props.match.params.PageType === "Refining-Settlement-Options"
      ? constants.REFINING_SETTLEMENT_OPTIONS
      : props.match.params.PageType === "Identifying-Your-Scrap"
      ? constants.IDENTIFYING_YOUR_SCRAP
      : props.match.params.PageType === "Payment-Options"
      ? constants.PAYMENT_OPTIONS
      : props.match.params.PageType === "Harmony-Jewelers"
      ? constants.HARMONY_JEWELERS
      : props.match.params.PageType === "Diamond-Education"
      ? constants.DIAMOND_EDUCATION
      : props.match.params.PageType === "Charities-And-Sponsorships"
      ? constants.CHARITIES_AND_SPONSERSHIPS
      : 1;

  useEffect(() => {
    window.scrollTo(0, 0);
    const query = qs.stringify({
      populate: {
        title: {
          populate: "*",
        },
        banner: {
          populate: "*",
        },
        twocolumns: {
          populate: "*",
        },
        threecards: {
          populate: "*",
        },
        bottomgreen: {
          populate: "*",
        },
        icons: {
          populate: "*",
        },
      },
    });
    api.fetchStrapi(`/sub-landing-pages/${page}?${query}`).then((response) => {
      setBanner(
        response.data.data.attributes.banner.data
          ? response.data.data.attributes.banner.data.attributes
          : null
      );
      setTwoColumns(response.data.data.attributes.twocolumns);
      setThreeCards(response.data.data.attributes.threecards);
      setBottomGreen(response.data.data.attributes.bottomgreen);
      setIcons(response.data.data.attributes.icons);
      setIsLoaded(true);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.match.params.PageType]);

  return (
    <>
      {!isLoaded ? (
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={true}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      ) : (
        <Container maxWidth="xl" className="careers-text">
          <Mobile>
            <Stack spacing={3} alignItems="center">
              {banner && (
                <img
                  src={`${frontImageUrl}${banner.url}`}
                  width="100%"
                  alt="banner"
                />
              )}
              {twocolumns &&
                twocolumns.map((twocolumn) => (
                  <>
                    <Stack spacing={3}>
                      <Typography variant="articleTitle" align="center">
                        {twocolumn.title}
                      </Typography>
                      <Grid container>
                        <Stack spacing={1}>
                          {twocolumn.leftimageplacement === "top" && (
                            <img
                              src={`${frontImageUrl}${twocolumn.leftimage.data.attributes.url}`}
                              width="100%"
                              alt="banner"
                            />
                          )}
                          <Typography variant="staticText">
                            <ReactMarkdown remarkPlugins={[remarkGfm]}>
                              {twocolumn.leftcolumn}
                            </ReactMarkdown>
                          </Typography>
                          {twocolumn.leftbutton && (
                            <DomLink
                              to={{ pathname: `${twocolumn.leftbutton.to}` }}
                              className="center"
                            >
                              <Button variant="contained">
                                {twocolumn.leftbutton.text}
                              </Button>
                            </DomLink>
                          )}
                          {twocolumn.leftimageplacement === "bottom" && (
                            <img
                              src={`${frontImageUrl}${twocolumn.leftimage.data.attributes.url}`}
                              width="100%"
                              alt="banner"
                            />
                          )}
                        </Stack>
                        <Stack>
                          {twocolumn.rightimageplacement === "top" && (
                            <img
                              src={`${frontImageUrl}${twocolumn.rightimage.data.attributes.url}`}
                              width="100%"
                              alt="banner"
                            />
                          )}
                          <Typography variant="staticText">
                            <ReactMarkdown remarkPlugins={[remarkGfm]}>
                              {twocolumn.rightcolumn}
                            </ReactMarkdown>
                          </Typography>
                          {twocolumn.rightbutton && (
                            <DomLink
                              to={{ pathname: `${twocolumn.rightbutton.to}` }}
                              className="center"
                            >
                              <Button variant="contained">
                                {twocolumn.rightbutton.text}
                              </Button>
                            </DomLink>
                          )}
                          {twocolumn.rightimageplacement === "bottom" && (
                            <img
                              src={`${frontImageUrl}${twocolumn.rightimage.data.attributes.url}`}
                              width="100%"
                              alt="banner"
                            />
                          )}
                        </Stack>
                      </Grid>
                      <Divider flexItem />
                    </Stack>
                  </>
                ))}

              {threecards && (
                <>
                  {threecards.title && (
                    <Typography variant="articleTitle">
                      {threecards.title}
                    </Typography>
                  )}
                  <Stack
                    direction="row"
                    key={threecards.id}
                    spacing={4}
                    align="center"
                    justifyContent="center"
                  >
                    <Card variant="outlined" sx={{ width: "33%" }}>
                      <img
                        src={`${frontImageUrl}${threecards.leftimage.data.attributes.url}`}
                        alt="left"
                        style={{ paddingTop: "2rem" }}
                      />
                      <CardContent>
                        <Typography variant="staticText">
                          <ReactMarkdown remarkPlugins={[remarkGfm]}>
                            {threecards.leftcard}
                          </ReactMarkdown>
                        </Typography>
                      </CardContent>
                    </Card>
                    <Card variant="outlined" sx={{ width: "33%" }}>
                      <img
                        src={`${frontImageUrl}${threecards.middleimage.data.attributes.url}`}
                        alt="middle"
                        style={{ paddingTop: "2rem" }}
                      />
                      <CardContent>
                        <Typography variant="staticText">
                          <ReactMarkdown remarkPlugins={[remarkGfm]}>
                            {threecards.middlecard}
                          </ReactMarkdown>
                        </Typography>
                      </CardContent>
                    </Card>
                    <Card variant="outlined" sx={{ width: "33%" }}>
                      <img
                        src={`${frontImageUrl}${threecards.rightimage.data.attributes.url}`}
                        alt="right"
                        style={{ paddingTop: "2rem" }}
                      />
                      <CardContent>
                        <Typography variant="staticText">
                          <ReactMarkdown remarkPlugins={[remarkGfm]}>
                            {threecards.rightcard}
                          </ReactMarkdown>
                        </Typography>
                      </CardContent>
                    </Card>
                  </Stack>
                </>
              )}
              <Typography
                variant="greenRectangle"
                align="center"
                sx={{ paddingLeft: "1rem", paddingRight: "1rem" }}
              >
                {bottomgreen.text}
              </Typography>
              <LandingFooter icons={icons} />
            </Stack>
          </Mobile>
          <Default>
            <Stack spacing={3} alignItems="center">
              {banner && (
                <img
                  src={`${frontImageUrl}${banner.url}`}
                  width="100%"
                  alt="banner"
                />
              )}
              {twocolumns &&
                twocolumns.map((twocolumn) => (
                  <>
                    <Stack spacing={3}>
                      <Typography variant="articleTitle" align="center">
                        {twocolumn.title}
                      </Typography>
                      <Grid container>
                        <Grid item xs={6} sx={{ paddingRight: "2.5rem" }}>
                          <Stack spacing={1}>
                            {twocolumn.leftimageplacement === "top" && (
                              <img
                                src={`${frontImageUrl}${twocolumn.leftimage.data.attributes.url}`}
                                width="100%"
                                alt="banner"
                              />
                            )}
                            <Typography variant="staticText">
                              <ReactMarkdown remarkPlugins={[remarkGfm]}>
                                {twocolumn.leftcolumn}
                              </ReactMarkdown>
                            </Typography>
                            {twocolumn.leftbutton && (
                              <DomLink
                                to={{ pathname: `${twocolumn.leftbutton.to}` }}
                                className="center"
                              >
                                <Button variant="contained">
                                  {twocolumn.leftbutton.text}
                                </Button>
                              </DomLink>
                            )}
                            {twocolumn.leftimageplacement === "bottom" && (
                              <img
                                src={`${frontImageUrl}${twocolumn.leftimage.data.attributes.url}`}
                                width="100%"
                                alt="banner"
                              />
                            )}
                          </Stack>
                        </Grid>
                        <Grid item xs={6} sx={{ paddingLeft: "2.5rem" }}>
                          <Stack>
                            {twocolumn.rightimageplacement === "top" && (
                              <img
                                src={`${frontImageUrl}${twocolumn.rightimage.data.attributes.url}`}
                                width="100%"
                                alt="banner"
                              />
                            )}
                            <Typography variant="staticText">
                              <ReactMarkdown remarkPlugins={[remarkGfm]}>
                                {twocolumn.rightcolumn}
                              </ReactMarkdown>
                            </Typography>
                            {twocolumn.rightbutton && (
                              <DomLink
                                to={{ pathname: `${twocolumn.rightbutton.to}` }}
                                className="center"
                              >
                                <Button variant="contained">
                                  {twocolumn.rightbutton.text}
                                </Button>
                              </DomLink>
                            )}
                            {twocolumn.rightimageplacement === "bottom" && (
                              <img
                                src={`${frontImageUrl}${twocolumn.rightimage.data.attributes.url}`}
                                width="100%"
                                alt="banner"
                              />
                            )}
                          </Stack>
                        </Grid>
                      </Grid>
                      <Divider flexItem />
                    </Stack>
                  </>
                ))}

              {threecards && (
                <>
                  {threecards.title && (
                    <Typography variant="articleTitle">
                      {threecards.title}
                    </Typography>
                  )}
                  <Stack
                    direction="row"
                    key={threecards.id}
                    spacing={4}
                    align="center"
                    justifyContent="center"
                  >
                    <Card variant="outlined" sx={{ width: "33%" }}>
                      <img
                        src={`${frontImageUrl}${threecards.leftimage.data.attributes.url}`}
                        alt="left"
                        style={{ paddingTop: "2rem" }}
                      />
                      <CardContent>
                        <Typography variant="staticText">
                          <ReactMarkdown remarkPlugins={[remarkGfm]}>
                            {threecards.leftcard}
                          </ReactMarkdown>
                        </Typography>
                      </CardContent>
                    </Card>
                    <Card variant="outlined" sx={{ width: "33%" }}>
                      <img
                        src={`${frontImageUrl}${threecards.middleimage.data.attributes.url}`}
                        alt="middle"
                        style={{ paddingTop: "2rem" }}
                      />
                      <CardContent>
                        <Typography variant="staticText">
                          <ReactMarkdown remarkPlugins={[remarkGfm]}>
                            {threecards.middlecard}
                          </ReactMarkdown>
                        </Typography>
                      </CardContent>
                    </Card>
                    <Card variant="outlined" sx={{ width: "33%" }}>
                      <img
                        src={`${frontImageUrl}${threecards.rightimage.data.attributes.url}`}
                        alt="right"
                        style={{ paddingTop: "2rem" }}
                      />
                      <CardContent>
                        <Typography variant="staticText">
                          <ReactMarkdown remarkPlugins={[remarkGfm]}>
                            {threecards.rightcard}
                          </ReactMarkdown>
                        </Typography>
                      </CardContent>
                    </Card>
                  </Stack>
                </>
              )}
              <Typography variant="greenRectangle" align="center">
                {bottomgreen.text}
              </Typography>
              <LandingFooter icons={icons} />
            </Stack>
          </Default>
        </Container>
      )}
    </>
  );
}
